import generateRender from 'shared/utils/generateRender';
import DefaultModalHeader from '../../../../components/JSModal/components/DefaultHeader';

const VipAccessHeader = generateRender({
  default: DefaultModalHeader,
});

export default VipAccessHeader;

